var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mb-12 text-center"},[_c('h1',{staticClass:"font-weight-light mb-2 headline",domProps:{"textContent":_vm._s(("" + _vm.heading))}})])}
var staticRenderFns = []

export { render, staticRenderFns }